import classNames from "classnames";

import { ApiService, Clinic } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapClinicToOptions = (clinics: Clinic[]) => [
  { value: "", label: "All Clinics", object: undefined },
  ...clinics
    .filter((clinic) => clinic.name)
    .map((clinic) => ({
      value: clinic.name,
      label: clinic.name,
      object: clinic,
    })),
];

const Selection = ({ object }: { object?: Clinic }) => {
  return (
    <div
      className={classNames("ClinicFilter__selection", {
        "ClinicFilter__selection--archived": object?.is_archived,
      })}
    >
      {object?.name ? (
        <>
          <span>{object.name}</span>
          {object.is_archived && (
            <code>
              <small>ARCHIVED</small>
            </code>
          )}
        </>
      ) : (
        "All Clinics"
      )}
    </div>
  );
};

const ClinicFilter = ({
  onChange,
  value,
}: {
  onChange: Function;
  value?: string;
}) => {
  return (
    <SelectSearchInput
      label="Clinic"
      field="clinic"
      filter="name"
      onChange={onChange}
      mapToOptions={mapClinicToOptions}
      apiService={ApiService.listClinics}
      component={Selection}
    >
      <>{value || "All Clinics"}</>
    </SelectSearchInput>
  );
};

export default ClinicFilter;
